import {Component, OnDestroy, OnInit} from '@angular/core';
import {finalize, Subject, takeUntil} from 'rxjs';
import {BreadcrumbService} from 'src/app/service/breadcrumb.service';
import {Grupo} from 'src/app/models/grupo.model';
import {GruposService} from 'src/app/service/grupos.service';
import {DataTablePage} from 'src/app/models/data-table-page.model';
import {UserService} from 'src/app/service/user.service';
import {StorageKeys} from 'src/app/shared/enums/storage-keys.enum';
import {OccurrenceService} from 'src/app/service/occurrence.service';
import {MotiveOccurrence} from 'src/app/models/occurrence.model';
import {ConfirmationService, MessageService} from 'primeng/api';
import { Contract } from 'src/app/models/user.model';
import { GA4Service } from 'src/app/service/ga4.service';

@Component({
  selector: 'app-motive-occurrence',
  templateUrl: './motive-occurrence.component.html',
  styleUrls: ['./motive-occurrence.component.scss']
})
export class MotiveOccurrenceComponent implements OnInit, OnDestroy {

  private _destroy$: Subject<void> = new Subject<void>();

  stylePattern = {'min-width': '100%', 'max-width': '100%', 'height': '40px'};

  page!: DataTablePage;
  loading: boolean = false;
  first: number = 0;
  totalRecords: number = 0;

  currentFilter: any = [];

  grupos!: Array<Grupo>;
  contract!: Array<Contract>;

  showCreateDialog = false;

  motiveOccurrenceData: MotiveOccurrence[] = [];

  motiveOccurrenceFilter: MotiveOccurrence = new MotiveOccurrence();
  newMotiveOccurrence: MotiveOccurrence = new MotiveOccurrence();

  buttonLoading: boolean = false;

  motiveOccurrenceType = [
    {name: 'Técnico', value: 'technical'},
    {name: 'Não técnico', value: 'nonTechnical'},
  ];

  editMode: boolean = false;

  notFound: boolean = false;
  tituloNotFound: string = 'Nenhum motivo ocorrência encontrado';
  descricaoNotFound: string = 'Desculpe, não encontramos nenhum motivo ocorrência para os filtros informados';

  selectedSort: string = '';
  sortDirection: number = 0; // 0 = neutro, 1 = ASC, -1 = DESC

  constructor(
    private breadCrumb: BreadcrumbService,
    private occurrenceService: OccurrenceService,
    private gruposService: GruposService,
    private userService: UserService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private ga4Service: GA4Service
  ) {
    this.page = new DataTablePage();
    this.page.size = 10;
    this.page.pageNumber = 0;
  }

  ngOnInit(): void {
    this.breadCrumb.next([
      {label: 'Configurações', icon: 'pi pi-sliders-v'},
      {label: 'Motivo Ocorrência', icon: 'pi pi-arrow-circle-right'}
    ]);
    this.getContract();
    this.ga4Service.trackActiveUserByScreen('Motivo Ocorrência', 'Motivo Ocorrência');
  }

  getContract(): void {
    const contratoSelecionado: any = this.userService.getCurrentContractAsList();

    if(!contratoSelecionado[0]?.id){
      return
    }

    this.motiveOccurrenceFilter.contractId = contratoSelecionado[0]?.id;
    this.contract = contratoSelecionado;
    this.grupos = contratoSelecionado;

    this.getMotiveOccurrence(false, this.motiveOccurrenceFilter);
  }

  showDialogCreate() {
    this.newMotiveOccurrence = new MotiveOccurrence();
    if(this.motiveOccurrenceFilter.contractId) {
      this.newMotiveOccurrence.contractId = this.motiveOccurrenceFilter.contractId;
    }
    this.editMode = false;
    this.showCreateDialog = true;
  }

  showEditDialog(item: any) {
    this.editMode = true;
    this.showCreateDialog = true;
    this.newMotiveOccurrence = JSON.parse(JSON.stringify(item));
  }

  customSort(field: string) {
    if (this.selectedSort === field) {
      if (this.sortDirection === 1) {
        this.sortDirection = -1;
      } else if (this.sortDirection === -1) {
        this.sortDirection = 0;
        this.selectedSort = '';
      }
    } else {
      this.selectedSort = field;
      this.sortDirection = 1;
    }

    this.loadMotiveOccurrences();
  }

  loadMotiveOccurrences() {
    this.notFound = false;
    this.loading = true;
    this.first = 0;
    this.page.pageNumber = 0;

    this.currentFilter = {
      description: this.motiveOccurrenceFilter.description,
      type: this.motiveOccurrenceFilter.type,
      contractId: this.motiveOccurrenceFilter.contractId,
      sortBy: this.sortDirection !== 0 ? this.selectedSort : null,
      sortOrder: this.sortDirection === 1 ? 'asc' : this.sortDirection === -1 ? 'desc' : null
    };

    if(this.currentFilter.contractId){
      this.currentFilter.grupos = this.currentFilter.contractId;
    } else {
      let userGroupsId: any = [];
      let user = JSON.parse(this.userService.decrypt(StorageKeys.USER));
      user.userGroups.forEach(async (e: any, index: number) => {
        userGroupsId.push(e.contractId);
      });
      this.currentFilter.grupos = userGroupsId.join(',');
    }

    this.occurrenceService.getMotiveOccurrence(this.page, this.currentFilter)
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => this.loading = false)
      )
      .subscribe({
        next: (data: any) => {
          this.totalRecords = this.page.totalElements;
          this.motiveOccurrenceData = data.content;
          if (!data.content || data.content.length === 0) {
            this.notFound = true;
            this.tituloNotFound = 'Nenhum motivo ocorrência encontrado';
            this.descricaoNotFound = 'Desculpe, não encontramos nenhum motivo ocorrência para os filtros informados';
          }
        }
      })
  }

  getMotiveOccurrence(pageEvent: any, filters: any) {
    this.notFound = false;
    this.loading = true;

    if (pageEvent === false) {
      this.page.pageNumber = 0;
      this.first = 0;
      this.selectedSort = '';
      this.sortDirection = 0;
    } else {
      this.page.size = pageEvent.rows;
      this.page.pageNumber = pageEvent.first / this.page.size;
    }

    if(filters === false){
      filters = [];
    }

    this.currentFilter = {
      description: filters.description,
      type: filters.type,
      contractId: filters.contractId,
      sortBy: this.sortDirection !== 0 ? this.selectedSort : null,
      sortOrder: this.sortDirection === 1 ? 'asc' : this.sortDirection === -1 ? 'desc' : null
    };

    if(this.currentFilter.contractId){
      this.currentFilter.grupos = this.currentFilter.contractId;
    } else {
      let userGroupsId: any = [];
      let user = JSON.parse(this.userService.decrypt(StorageKeys.USER));
      user.userGroups.forEach(async (e: any, index: number) => {
        userGroupsId.push(e.contractId);
      });
      this.currentFilter.grupos = userGroupsId.join(',');
    }

    this.occurrenceService.getMotiveOccurrence(this.page, this.currentFilter)
      .pipe(takeUntil(this._destroy$),
      finalize(() => {
        this.loading = false;
      }),
      )
      .subscribe({
        next: (data: any) => {
          this.totalRecords = this.page.totalElements;
          this.motiveOccurrenceData = data.content;
          if (!data.content || data.content.length === 0) {
            this.notFound = true;
            this.tituloNotFound = 'Nenhum motivo ocorrência encontrado';
            this.descricaoNotFound = 'Desculpe, não encontramos nenhum motivo ocorrência para os filtros informados';
          }
        }
      })
  }

  formatTechnical(res: string) {
    const find = this.motiveOccurrenceType.find(e => e.value == res);
    if(find) {
      return find.name
    } else {
      return '-'
    }
  }

  updateMotiveOccurrence() {
    this.buttonLoading = true;
    if(!(this.newMotiveOccurrence.serviceTime != null && this.newMotiveOccurrence.contractId != null && this.newMotiveOccurrence.type != null)) return;
    this.occurrenceService.updateMotiveOccurrence(this.newMotiveOccurrence)
    .pipe(takeUntil(this._destroy$),
    finalize(() => {
      this.buttonLoading = false;
    }),
    )
    .subscribe({
      next: (res) => {
        this.showCreateDialog = false;
        this.newMotiveOccurrence = new MotiveOccurrence();
        this.messageService.add({
          key: 'toastSuccess',
          severity: 'success',
          detail: 'Motivo ocorrência atualizado com sucesso!',
        });
        this.getMotiveOccurrence(false, this.motiveOccurrenceFilter);
      },
      error: (error) => {
        let errorMsg = 'Erro ao tentar atualizar o motivo ocorrência';

        if (error.status === 409) {
          errorMsg = 'Já existe um motivo de ocorrência com essa descrição para este agrupador.';
        }

        this.messageService.add({
          key: 'toastError',
          severity: 'error',
          summary: 'Error',
          detail: errorMsg,
        });
      }
    })
  }

  createMotiveOccurrence(){
    this.buttonLoading = true;
    if(!(this.newMotiveOccurrence.description != null && this.newMotiveOccurrence.serviceTime != null && this.newMotiveOccurrence.contractId != null && this.newMotiveOccurrence.type != null)) return;

    this.occurrenceService.saveMotiveOccurrence(this.newMotiveOccurrence)
    .pipe(takeUntil(this._destroy$),
    finalize(() => {
      this.buttonLoading = false;
    }),
    )
      .subscribe({
        next: (res) => {
          this.showCreateDialog = false;
          this.messageService.add({
            key: 'toastSuccess',
            severity: 'success',
            detail: 'Motivo ocorrência salvo com sucesso!',
          });
          this.getMotiveOccurrence(false, this.motiveOccurrenceFilter);
        },
        // Por conta da arquitetura do back, que não envia a mensagem, a identificacão do erro está sendo feita pelo status 409
        error: (error) => {
          let errorMsg = 'Erro ao tentar salvar motivo ocorrência';

          if (error.status === 409) {
            errorMsg = 'Já existe um motivo de ocorrência com essa descrição para este agrupador.';
          }

          this.messageService.add({
            key: 'toastError',
            severity: 'error',
            summary: 'Error',
            detail: errorMsg,
          });
        }
      })
  }

clearFilter() {
  this.motiveOccurrenceFilter = new MotiveOccurrence();

  this.selectedSort = '';
  this.sortDirection = 0;
  this.first = 0;

  const contratoSelecionado: any = this.contract;
  if (contratoSelecionado?.[0]?.id) {
    this.motiveOccurrenceFilter.contractId = contratoSelecionado[0].id;
  }

  this.getMotiveOccurrence(false, this.motiveOccurrenceFilter);
}

onlyNumbers(event: KeyboardEvent) {
  const charCode = event.which ? event.which : event.keyCode;

  if (charCode < 48 || charCode > 57) {
    event.preventDefault();

    this.messageService.add({
      key: 'toastError',
      severity: 'error',
      detail: 'Este campo aceita apenas números.'
    });
  }
}

validateForm(): boolean {

  if (!this.newMotiveOccurrence.contractId) {
    this.showError('Campo Grupo é obrigatório.');
    return false;
  }

  if (!this.newMotiveOccurrence.description) {
    this.showError('Campo Descrição é obrigatório.');
    return false;
  }

  if (!this.newMotiveOccurrence.type) {
    this.showError('Campo Agrupador é obrigatório.');
    return false;
  }

  if (this.newMotiveOccurrence.serviceTime == null) {
    this.showError('Campo Tempo de Atendimento é obrigatório.');
    return false;
  }

  if (!Number.isInteger(this.newMotiveOccurrence.serviceTime) || this.newMotiveOccurrence.serviceTime <= 0) {
    this.showError('Formato de horas inválido. Informe um número inteiro maior que zero.');
    return false;
  }

  return true;
}

showError(message: string) {
  this.messageService.add({
    key: 'toastError',
    severity: 'error',
    detail: message
  });
}

  deleteMotiveOccurrence(occurrenceId: number) {
    this.occurrenceService.deleteMotiveOccurrence(occurrenceId)
      .pipe(
        takeUntil(this._destroy$),
      )
      .subscribe({
        next: () => {
          this.messageService.add({
            key: 'toastSuccess',
            severity: 'success',
            detail: 'Motivo de ocorrência excluído com sucesso!',
          });
          this.getMotiveOccurrence(false, this.motiveOccurrenceFilter);
        },
        // Por conta da arquitetura do back, que não envia a mensagem, a identificacão do erro está sendo feita pelo status 409
        error: (e) => {
          let errorMsg = 'Erro ao tentar excluir o motivo de ocorrência.';

          if (e.status === 409) {
            errorMsg = 'Não é possível excluir o motivo de ocorrência, pois existem ocorrências vinculadas a ele.';
          }

          this.messageService.add({
            key: 'toastError',
            severity: 'error',
            summary: 'Error',
            detail: errorMsg,
          });
        },
      })
  }

  openDeleteConfirm(id: number, desc: string) {
    this.confirmationService.confirm({
      message: 'Você realmente deseja deletar o motivo de ocorrência: ' + desc,
      header: 'Deletar motivo de ocorrência',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Excluir',
      rejectLabel: 'Cancelar',
      acceptIcon: 'pi pi-trash mr-1',
      rejectIcon: 'pi pi-times mr-1',
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary mr-2',
      accept: () => this.deleteMotiveOccurrence(id),
      reject: () => { }
    })
  }

  clearCreateForm() {
    const id = this.editMode ? this.newMotiveOccurrence.id : null;
    this.newMotiveOccurrence = new MotiveOccurrence();

    if (id) {
      this.newMotiveOccurrence.id = id;
    }

    if (this.motiveOccurrenceFilter.contractId) {
      this.newMotiveOccurrence.contractId = this.motiveOccurrenceFilter.contractId;
    }
  }


  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
